module.exports = require("live/components/forms/mixins/object-initializer");